module.exports = __webpack_public_path__ + "img/food_dounut.42a4ecae.png";